

export default {
    changeSwiperOptions(state,type){
        state.type = type;
    }
};
